export const phrases = {
  heading_settings_sort: "Personel listesini sıralama",
  body_settings_sort: "Personel listesini ad veya soyadına göre sıralayın.",
  since_o_clock: "{time} saatinden beri",
  old_data_warning_my_area: "Herhangi bir yeni bilgi yükleyemedik. İnternete bağlı olduğunuzdan emin olun.",
  no_data_warning_my_area: "İnternete bağlı olduğunuzdan emin olun ve tekrar deneyin.",
  no_data_available_my_area: "Veri yüklenemiyor",
  last_update_data: "Son güncelleme",
  something_went_wrong_absences: "Bir şeyler yanlış gitti. Lütfen daha sonraki bir tarihte tekrar deneyin.",
  something_went_wrong_with_the_pin_entry: "PIN girişinde bir sorun var...",
  pin_must_be_four_digits: "PIN tam olarak dört rakamdan oluşmalıdır.",
  pins_do_not_match: "Girilen PIN'ler eşleşmiyor.",
  pin_is_not_numerical: "PIN yalnızca rakamlardan oluşabilir.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Damga vurun",
  finish_break: "Mola sonu",
  finish_loading_time: "Yükleme süresini sonlandır",
  finish_driving_time: "Sürüş süresi sonu",
  finish_business_trip: "Görev süresinin sonu",
  finish_project_as_task: "Projeyi bitirin",
  finish_special_one: "Özel1'i sonlandırın",
  finish_special_two: "Son Özel2",
  you_clockout: "Kendini damgalıyorsun",
  sentence_work_time: "Çalışıyorsunuz. | Şu anda çalışıyorsun.",
  sentence_break: "Mola veriyorsunuz. | Mola veriyorsun.",
  sentence_loading_time: "Şu anda yükleme süresini kaydediyorsunuz. Hauruck! | Şu anda yükleme süresini kaydediyorsunuz. Jerk!",
  sentence_business_trip: "Servis giriş yaptı. İyi eğlenceler!",
  sentence_driving_time: "Sürüş zamanını ayarlıyorsun. Kemerlerinizi bağlayın ve gidin! | Seyahat süresi için rezervasyon yapıyorsunuz. Kemerlerinizi bağlayın ve gidin!",
  sentence_special_one: "Özel 1 için rezervasyon yapıyorsunuz. | Özel 1 için rezervasyon yapıyorsunuz.",
  sentence_special_two: "Özel 2 için rezervasyon yapıyorsunuz. | Özel 2 için rezervasyon yapıyorsunuz.",
  sentence_custom_time: "Rezervasyon yapıyorsunuz | Rezervasyon yapıyorsunuz",
  you_are_booked_in_activity: "{activity}'u damgalıyorsunuz! | {activity}'u damgalayın!",
  substitute_warning: "{ days } Gün veya daha uzun süreli devamsızlıklar için bir vekil tayin edilmelidir.",
  substituted_by: "Tarafından temsil edilmektedir",
  name_clocked_in: "{name} damgalı",
  /************************************/
  //Signature stuff:

  signature: "İmza",
  please_sign: "Lütfen imzalayın",
  signature_with_date: "{date}adresinden imza",
  signature_with_date_with_name: "{name}adresinden {date} imzası",
  signature_with_date_with_location: "İmza {date} in {location}",
  signature_with_date_with_name_with_location: "{name} adresinden {date} imzası {location}",
  signature_with_name: "İmza {name}",
  signature_with_name_with_location: "İmza {name} in {location}",
  signature_with_location: "İmza {location}adresinde",
  /*************************************/

  accept_terms_and_conditions: "Formu göndererek {agb} ve {datenschutzerklaerung}adreslerimizi kabul etmiş olursunuz.",
  what_is_your_name: "Adın ne senin?",
  your_email: "E-posta adresiniz",
  what_is_your_company_name: "Şirketinizin adı nedir?",
  what_do_you_want_to_do_with_clockin: "Clockin ile ne yapmak istiyorsun?",
  almost_finished: "Neredeyse vardık",
  test_clockin_for_amount_period: "Clockin {amountOfDaysTestPeriod} adresini birkaç günlüğüne ücretsiz deneyin!",
  code_needed_to_connect: "Kodunuzu kullanın",
  you_have_no_company_code: "Kodunuz yok mu? Şirketinizdeki kişiyle iletişime geçin.",
  connect_your_device: "Cihazınızı bağlayın!",
  please_type_in_device_id: "Lütfen web sitemizde mobil cihazlar altında bulabileceğiniz cihaz kimliğini girin.",
  new_at_clockin: "Clockin'de yeni misiniz?",
  pin_repeat: "PIN'i Tekrarla",
  configure_your_pin: "4 haneli PIN kodunuzu ayarlayın",
  configure_your_pin_text: "Tablet terminalindeki kişisel alanınıza erişmek için PIN koduna ihtiyacınız vardır.",
  congratulations: "Tebrikler!",
  start_now: "Şimdi başlayın",
  device_name_info: "Birkaç cihazı takip edebilmek için mobil cihazınızın cihaz adını değiştirebilirsiniz. Örnek: \"Akıllı Telefon MaxMustermann\". İsim daha sonraki bir tarihte de değiştirilebilir.",
  select_project: "Proje seçiniz",
  select_time: "Seçme zamanı",
  create_new_account: "Yeni hesap oluştur",
  join_my_company: "Şirketime katıl",
  join_clockin_with_qr: "QR kodu ile katılın",
  change_project: "Değişim projesi",
  my_messages: "Benim Haberlerim",
  my_documents: "Belgelerim",
  my_data_and_passwords: "Verilerim ve Şifrelerim",
  my_account_data: "Benim verilerim",
  change_my_password: "Şifre değiştirme",
  forgot_password: "Şifremi bilmiyorum.",
  open_camera: "Açık kamera",
  scan_now: "Şimdi tara",
  sync_now: "Şimdi senkronize et",
  clear_logs: "Boş günlükler",
  saveAndGoBack: "Kaydet ve geri dön",
  full_day: "Tam gün",
  activate_scanner: "Tarayıcı etkinleştirildi",
  scanner_is_inactive: "Tarayıcı etkin değil",
  change_project_by_scan_qr: "Geçiş yapmak istediğiniz projenin QR kodunu tarayın.",
  scan_device_by_qr: "Kullanmak istediğiniz cihazdan QR kodunu tarayın.",
  no_access_to_camera_please_connect_device_manually: "Maalesef kameraya erişilemedi, lütfen cihaz kodunu manuel olarak girin.",
  no_access_to_camera_please_clockin_manually: "Maalesef kameraya erişim mümkün olmadı, lütfen manuel olarak damgalayın.",
  qr_code_login: "QR kod kaydı",
  scan_to_login: "Giriş yapmak için QR kodunuzu tarayın.",
  checklist_was_saved: "Kontrol listesi kaydedildi",
  question_save_changes_short: "Değişiklikleri kaydedelim mi?",
  question_save_changes: "Değişiklikleri kaydetmek istiyor musunuz?",
  question_delete_checklist_short: "Kontrol listesini silelim mi?",
  question_delete_checklist: "Kontrol listesini silmek istediğinizden emin misiniz?",
  checklist_is_sending: "Kontrol listesi gönderilecek",
  checklist_sent_successfully: "Kontrol listesi başarıyla 🎉 gönderildi",
  checklist_could_not_be_sent: "Kontrol listesi gönderilemedi, lütfen daha sonra tekrar deneyin.",
  checklist_transmission_problems_in_the_past: "Geçmişte, bazı dosyalarda aktarım sorunları yaşanmıştır.",
  checklist_send_with_potential_data_loss: "Kontrol listesini bu dosyalar olmadan göndermeyi denemek ister misiniz?",
  documentation_is_sending: "Proje belgeleri gönderilir",
  documentation_sent_successfully: "Proje belgeleri başarıyla gönderildi 🎉",
  confirm_documentation_dismissal: "Belgeleri gerçekten atmak istiyor musunuz?",
  discard_unsaved_changes: "Değişikliklerinizi atmak mı istiyorsunuz?",
  documentation_will_be_sent_when_online: "Belgeler, siz tekrar çevrimiçi olur olmaz gönderilecektir.",
  confirmation_is_sending: "Proje onayı gönderilir",
  ask_for_geo_permission: "Bu uygulamanın konumunuza ihtiyacı var, " + "ancak bunu yapmak için izni yoktur.\n\n" + "Ayarları açmak istiyor musunuz?",
  all_projects: "Tüm projeler",
  half_day: "Yarım gün",
  start_end: "Zamana göre",
  my_area: "Benim bölgem",
  my_area_video_teaser_clockin_explained_by_frederik: "Clockin Freddi tarafından açıklandı",
  add_time: "Zaman yaratın",
  show_times_in_confirmation: "Gösteri saatleri onaylandı",
  change_time: "Değişim zamanı",
  finish_project: "Projeyi tamamlayın",
  finish_project_date: "Randevuyu kesinleştirin",
  unfinish_project: "Projeyi yeniden aç",
  unfinish_project_date: "Randevuyu yeniden açın",
  absence_overview: "Devamsızlıkları yönetin",
  edit_absence: "Düzenleme yokluğu",
  edited_absence: "Devamsızlık düzenlendi",
  created_absence: "Ayrılma talebi başarıyla oluşturuldu",
  creating_absence: "İzin talebiniz şimdi oluşturuldu",
  error_creating_absence: "Devamsızlık talebi oluşturulurken hata oluştu",
  create_absence: "Devamsızlık oluşturun",
  deleted_absence: "Devamsızlık talebinin geri çekilmesi",
  new_request: "Yeni uygulama",
  your_requests: "Başvurularınız",
  planned_days: "Planlanmış günler",
  planned_hours: "Planlanan saatler",
  used_days: "Kullanılan günler",
  used_hours: "Harcanan saatler",
  free_days: "İzin günleri",
  free_hours: "Tatil saatleri",
  open_days: "Açık günler",
  open_hours: "Çalışma saatleri",
  withdraw_request: "Başvuruyu geri çekme",
  change_request: "Değişiklik talebi",
  request_was_approved: "Başvurunuz onaylandı",
  request_is_pending: "Başvurunuz henüz onaylanmadı",
  request_was_rejected: "Başvurunuz reddedildi",
  add_attachment: "Eklenti ekle",
  message_optional: "Mesaj (isteğe bağlı)",
  filed_on: "Gönderildiği tarih",
  this_year: "Bu yıl",
  search_sub_projects: "Hangi alt proje üzerinde çalışmak istersiniz?",
  error_occurred: "Bir hata oluştu, daha sonra tekrar deneyin.",
  re_record: "Bu videoyu silip yeniden kaydetmek mi?",
  delete_video: "Kaydı silmek mi?",
  no_results_found: "Sonuç bulunamadı",
  record_again: "Yeni -den deneme",
  request_valid_email: "Lütfen geçerli bir e-posta adresi girin.",
  request_valid_company_name: "Lütfen geçerli bir şirket adı girin.",
  request_valid_first_name: "Lütfen geçerli bir ilk ad girin.",
  request_valid_last_name: "Lütfen geçerli bir soyadı girin.",
  total_duration_today: "Bugünkü toplam süre",
  show_daily_protocol: "Günlük kaydı göster",
  change_profile_pic: "Profil resmini değiştir",
  logout_account: "Hesap bağlantısını kes",
  you_are_working: "Şu anda çalışıyorsun!",
  you_are_taking_a_break: "Ara verdin!",
  activity_edited: "Etkinlik düzenlendi",
  activity_edited_undo: "İşlem başarıyla geri alındı",
  activity_edited_missing_project: "Oh, proje hala kayıp!",
  activity_deleted: "Faaliyet silindi",
  activity_deleted_undo: "Silinen etkinlik geri yüklendi",
  activity_created: "Yeni etkinlik oluşturuldu",
  activity_created_undo: "Yeni oluşturulan faaliyet geri çekildi",
  correct_working_hours: "Doğru çalışma süreleri",
  your_changes_are_being_saved: "Değişiklikleriniz artık kaydedilmiştir.",
  manage_working_hours: "Çalışma saatlerini yönetin",
  delete_activity: "Etkinliği sil",
  start_navigation: "Navigasyonu başlat",
  no_valid_email: "Girilen e-posta adresi geçerli değil.",
  delete_checklist: "Kontrol listesini sil",
  active_checklists: "Aktif kontrol listeleri",
  scan_qr_code: "QR kodunu tarayın",
  switch_to_office_center: "Ofis merkezine geçin",
  confirm_project_completion_short: "Projeyi tamamlayın",
  confirm_project_date_completion_short: "Randevuyu kesinleştirin",
  project_completed: "Proje tamamlandı!",
  project_date_completed: "Randevu kesinleşti!",
  confirm_project_uncompletion_short: "Projeyi yeniden aç",
  confirm_project_date_uncompletion_short: "Randevuyu yeniden açın",
  project_uncompleted: "Proje etkinleştirildi",
  project_date_uncompleted: "Etkinleştirildiği tarih",
  choose_project: "Proje seçiniz",
  choose_sub_project: "Alt proje seçin",
  choose_site: "Konum seçin",
  active_projects: "Aktif projeler",
  completed_term: "tamamlandı",
  completed_projects: "Tamamlanan projeler",
  end_of_work: "İyi akşamlar dilerim",
  correct_time: "Doğru zaman",
  you_stamp_x: "Sen damgala.",
  enter_pin: "Lütfen PIN kodunu girin",
  wrong_pin: "Hatalı PIN girişi",
  pin_change_required: "PIN kodunuzu değiştirmeniz istendi",
  enter_new_pin: "Yeni PIN girin",
  approve_pin: "PIN kodunu onayla",
  no_projects_scheduled: "İçin {day} hiçbir proje saklanmaz.",
  you_clock_in_project: "Şu andan itibaren proje çalışma süresini kaydedersiniz.",
  project_scan_error: "Bu kod hiçbir proje için geçerli değildir.",
  show_more_days: "daha fazla gün göster",
  show_more_times: "Daha fazla zaman göster",
  only_show_today: "Sadece bugün göster",
  todays_total_time: "Bugünkü toplam süre",
  everything_synced: "Verileriniz güncel!",
  upload_in_progress: "Veriler yüklenir...",
  who_are_you: "Kimsin?",
  is_uploading_to_server: "Değişiklikleriniz ofis merkezine aktarılıyor.",
  offline_and_data_is_stored_locally: "Değişiklikleriniz kısa süre içinde ofis merkezine aktarılacaktır. ",
  show_more: "daha fazla göster",
  activity_edited_wrong_date: "Yanlış tarih girdiniz.",
  confirm_logout: "Gerçekten abonelikten çıkmak istiyor musunuz?",
  confirm_clockout: "Bugünlük paydos etmek istediğine emin misin?",
  gps_is_active: "GPS verileri iletilir",
  location_tracking_is_active: "GPS izlemeyi etkinleştirmek için.",
  app_settings: "Uygulama ayarları",
  clock_reminder: "Pul - Hatırlatma",
  mon_to_fri: "Standart: Pazartesi - Cuma",
  logout: "Hesap bağlantısını kes",
  refresh: "Güncelleme",
  prompt_language_settings: "Uygulamanın dilini buradan ayarlayın.",
  prompt_clock_reminder: "Günlük işinizle uyumlu hale getirmek için push bildirimiyle hatırlatma.",
  register_company: "Şirket kaydı",
  use_code: "Kodu kullanın",
  our_customers: "Müşterilerimiz",
  free_test_now: "Test şimdi ücretsiz",
  tier_attendance: "Sadece çalışma saatlerini ve molaları kaydediyorum.",
  tier_documentation: "Ayrıca, yönettiğim projelerde çalışma saatlerini saat içinde kaydetmek istiyorum.",
  your_tier: "Paketiniz",
  all_clockin_functions: "Tüm clockin fonksiyonları",
  checklists_formulars: "Kontrol Listeleri ve İşlevler",
  projectfile_incl_chat: "Dijital proje dosyaları (sohbet dahil)",
  photo_sketch_note: "Fotoğraf, eskiz ve not fonksiyonu",
  digital_signature: "Dijital imzalar",
  datev_connection: "DATEV bağlantısı",
  calendar_absences: "Takvim ve Devamsızlıkları Yönetme",
  individual_design: "Bireysel görünüm",
  attendance_time_tracking: "Tablet terminali üzerinden sabit zaman kaydı",
  mobile_time_tracking: "Akıllı telefon uygulaması üzerinden mobil zaman kaydı",
  browser_time_tracking: "Ev ofisi için PC'de tarayıcı zaman kaydı",
  help_use_code: "Lütfen ofis merkezinde mobil cihazlar/çalışanlar altında bulduğunuz kodu girin.",
  wrong_code: "Yanlış kod",
  wrong_code_text: "Kod geçerli değil. Lütfen geçerli bir kodla tekrar deneyin",
  wrong_code_text_short: "Kod geçersiz",
  clockin_logo: "Clockin Logosu",
  invalid_qr_code: "Geçersiz QR kodu",
  invalid_qr_code_text: "Taranan QR kodu geçerli değil. Lütfen geçerli bir saat kodunu tarayın.",
  code_already_connected: "Bu kod ile cihazınızı bağlayabilirsiniz. Ama zaten bağlısınız.",
  wrong_credentials: "Yanlış erişim verileri",
  wrong_credentials_text: "Girdiğiniz e-posta ve şifre kombinasyonu bulunamadı. Lütfen girişinizi kontrol edin ve tekrar deneyin.",
  new_pin: "Yeni PIN girin",
  choose_next_action: "Bir sonraki eyleminizi seçin",
  name_of_software_package: "Yazılım paketinin adı",
  select_teamleader: "Takım için kim damga vuruyor?",
  select_teamleader_description: "Damgalama faaliyetlerine devam etmek için lütfen makineyi devralacak bir kişi seçin.",
  clocked_in_on_this_device: "Bu ünite üzerine damgalanmıştır",
  not_clocked_in_on_this_device: "Bu ünite üzerinde damgalanmamıştır",
  select_new_teamleader: "Takıma şimdi kim damga vurmalı?",
  switch_teamleader: "Birimi teslim edin",
  just_me: "Sadece mesai bitimi",
  select_the_new_teamleader: "Yeni ekip liderini belirleyin",
  back_to_selection: "seçime geri dön",
  manage_team: "Ekip yönetmek",
  total_time_team: "Ekibin toplam süresi",
  count_members_clocked_in: "{clockedin}/{members} Ekip üyeleri mühürlendi",
  whole_team: "Tüm ekip",
  teammembers_still_clockedin: "Sadece kendinizin mi yoksa ekipteki herkesin mi mesaisini bitirmek istediğinizi seçin?",
  clockout_all: "Hepsini yok et",
  select_employee: "Önce bir kullanıcı seçin",
  something_went_wrong: "Bir şeyler ters gitti, lütfen daha sonra tekrar deneyin.",
  new_pin_successfully_changed: "PIN başarıyla değiştirildi",
  enter_pin_before_clockin_prompt: "İlk olarak, giriş yapmak için PIN kodunuzu teker teker girin.",
  enter_pin_before_clockout_prompt: "Çıkış yapmak için önce PIN kodunuzu teker teker girin.",
  delete_activity_alert_title: "Etkinliği sil",
  delete_activity_alert_msg: "Etkinliği silmek istediğinizden emin misiniz?",
  delete_absence_message: "Başvurunuzu geri çekmek istediğinizden emin misiniz?",
  delete_absence_title: "Başvuruyu geri çekme",
  are_you_sure: "Emin misin?",
  request_password: "Yeni şifre iste",
  password_requested: "E-posta adresinize yeni bir şifre için bir bağlantı gönderildi.",
  no_email_retrieved: "E-posta almadınız mı? Lütfen spam klasörünüzü kontrol edin veya tekrar deneyin.",
  name_of_customer: "Müşterinin adı",
  missing_permissions_homepage_text: "Bu makinedeki etkinliğinizi değiştirmek için izniniz yok. Erişim sağlamak için lütfen yöneticinize başvurun.",
  no_permission_warning_my_area: "Bu alana erişim izniniz yok. Erişim sağlamak için lütfen yöneticinizle iletişime geçin.",
  employee_clocked_in: "{name} Kayıtlı!",
  employee_clocked_out: "{name} Oturumu kapattım!",
  no_employee_to_qr_code_warning: "Bu QR kodu için hiçbir çalışan bulunamadı.",
  no_employees_registered_heading: "Bu birime henüz personel atanmamıştır.",
  no_employees_registered_body: "Ofis merkezinde mobil cihaz ayarlarında, daha sonra zamanlarını bu cihaza kaydetmelerine izin verilen çalışanları atayabilirsiniz.",
  no_employee_found: "Ne yazık ki bu isimde kimse bulunamamıştır.",
  no_employee_assigned: "Çalışan atanmadı",
  you_need_help: "Yardıma ihtiyacın var mı?",
  here_you_can_get_help_to_register_employees_for_device: "Burada, personelin bir birime nasıl atanacağına ilişkin tüm bilgileri bulacaksınız.",
  show_time: "Zaman yaratın",
  export_timesheet: "Zaman çizelgesini dışa aktar",
  select_month: "Ay seçin",
  internet_connection_required: "Bunun için bir İnternet bağlantısı gereklidir.",
  select_an_activity_to_clockin_your_team: "Ekibinize damga vurmak için bir etkinlik seçin.",
  confirm_uploading_sqlite_for_debugging: "Clockin desteği için uygulamadaki verileri yüklemek istediğinizden emin misiniz?",
  no_tasks_available: "Görev mevcut değil",
  click_to_add_tasks: "Görevleri eklemek için tıklayın",
  scan_nfc_tag: "Lütfen kartınızı okuyucuya doğru tutun.",
  link_nfc_tag: "NFC etiketini bağla",
  select_employee_for_nfc_tag: "Lütfen bu NFC etiketini bağlamak için bir çalışan seçin:",
  nfc_tag_linked_successfully: "NFC etiketi ile başarılı bir şekilde {name} Bağlantılı.",
  nfc_linking_failed: "NFC etiketi bağlanamadı. Lütfen tekrar deneyin.",
  nfc_not_enabled: "NFC bu cihaz tarafından desteklenmiyor veya devre dışı.",
  nfc_initialization_failed: "Ne yazık ki, bir şeyler ters gitti. Lütfen tekrar deneyin.",
  nfc_scan_failed: "Ne yazık ki, bir şeyler ters gitti. Lütfen tekrar deneyin.",
  nfc_no_tag_found: "NFC etiketi bulunamadı.",
  nfc_tag_already_linked_to: "Bu NFC etiketi zaten mevcut {name} Bağlantılı.",
  nfc_scan_active: "NFC taraması etkin",
  nfc_linking_enabled: "NFC etiketleri artık bağlanabilir. NFC okuyucuya bağlanmak için lütfen NFC etiketini şimdi tutun.",
  nfc_all_employees_linked: "Bu cihaza atanan tüm çalışanlar zaten bağlanmıştır.",
  no_employee_to_nfc_warning: "Bu NFC etiketi için çalışan bulunamadı.",
  select_employee_to_link_nfc: "NFC etiketi kime bağlanmalıdır?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Clockin'e hoş geldiniz",
        clocking_time: "Pist süreleri",
        push_notifications: "Hiçbir şeyi unutma"
      },
      text: {
        clocking_time: "Clocker her aktivite için başlangıç noktanızdır. Sen işinle ilgileniyorsun, uygulama dokümantasyonu yapıyor.",
        push_notifications: "Şimdi bildirimleri açın. Clockin, bir pulu unutursanız hatırlatır ve önemli her şeyi hemen aldığınızdan emin olur."
      },
      button: {
        lets_go: "Şimdi başlayın"
      }
    },
    my_area: {
      heading: {
        my_area: "Benim bölgem",
        absences: "Devamsızlıklar ve başvurular",
        settings: "Kişisel ayarlar"
      },
      text: {
        my_area: "Çalışma saatlerinizi ve fazla mesailerinizi anında görebileceğiniz merkezi bir yer. Buradan çalışma saatlerinizi yönetebilir, günlük günlüğünüze erişebilir, talep gönderebilir ve zamanlarınızı görüntüleyebilirsiniz.",
        absences: "Tatil taleplerini, hastalık günlerini ve diğer devamsızlıkları yönetin. Taleplerinizin durumunu her zaman takip edin ve sadece birkaç tıklama ile yenilerini hızlı ve kolay bir şekilde gönderin.",
        settings: "Şirkete mesaj gönderin veya kişisel ayarlarınızı değiştirin ve şifrenizi değiştirmek istiyorsanız, bunu da buradan yapabilirsiniz!"
      },
      button: {
        lets_go: "Başlayın"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Çünkü zamanınız önemli",
        clock_in: "Pul içeri",
        switch_task: "Pul değişikliği",
        clock_out: "Damga vurun",
        thats_it: "Bu kadar!"
      },
      text: {
        your_time_matters: "Clockin ile temel konulara konsantre olmanıza yardımcı oluyoruz. Tek bir tıklama ile çalışma sürenizi kaydedin.",
        clock_in: "Tek bir tıklama ile doğrudan saatiniz kaydedilir. Clockin verilerinizi otomatik olarak kaydeder ve her zaman her şeyi görebilirsiniz.",
        switch_task: "Başka bir projeniz mi var, ara mı verdiniz veya bir sonraki randevunuza mı gidiyorsunuz? Yeni etkinliğiniz için kendinizi yeniden damgalamanız yeterlidir. Gerisi otomatik olarak kaydedilir.",
        clock_out: "Ve tek bir tıklama ile damgalanırsınız.",
        thats_it: "Bunu yaptınız ve çalışma sürenizi kaydetmeye hazırsınız. Yardıma ihtiyacınız olursa bizimle iletişime geçmeniz yeterli. Clockin ile her şey çok kolay - bizimle iletişim kurmak da dahil."
      },
      button: {
        your_time_matters: "Bana nasıl yapıldığını göster",
        thats_it: "Şimdi başlayın"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Çünkü zamanınız önemli",
        clock_in: "Pul içeri",
        clock_in_team: "Giriş ekibi",
        switch_task: "Pul değişikliği",
        change_teamleader: "Birimi teslim edin",
        clock_out: "Damga vurun",
        thats_it: "Bu kadar!"
      },
      text: {
        your_time_matters: "Clockin ile temel konulara konsantre olmanıza yardımcı oluyoruz. Ekibinizin çalışma saatlerini tek bir tıklama ile kaydedin.",
        clock_in: "Ekip için saat tutan bir kişi seçin ve tek bir tıklama ile doğrudan saat tutulur. clockin verilerinizi otomatik olarak kaydeder ve her zaman her şeye göz kulak olabilirsiniz.",
        clock_in_team: "Ekibinizi doğrudan damgalamanız yeterlidir. İster hepsi aynı anda ister tek tek üyeler.",
        switch_task: "Başka bir projeniz mi var, ara mı verdiniz ya da bir sonraki randevunuza mı gidiyorsunuz? Yeni faaliyetinizi damgalamanız yeterlidir. Gerisi otomatik olarak kaydedilecektir.",
        change_teamleader: "İşiniz bitti, ayrılmak zorundasınız ya da artık ekip için saat tutmayacak mısınız? Uygulamadaki cihazı teslim edin ve her şey normale dönsün.",
        clock_out: "Ve tek bir tıklamayla siz ve ekibinizin mesaisi biter. Elbette, istediğiniz zaman tek tek üyelerin de çıkışını yapabilirsiniz.",
        thats_it: "Bunu yaptınız ve ekibiniz için çalışma süresini kaydetmeye hazırsınız. Yardıma ihtiyacınız olursa bizimle iletişime geçmeniz yeterli. Clockin ile her şey çok kolay - bizimle iletişim kurmak da dahil."
      },
      button: {
        your_time_matters: "Bana nasıl yapıldığını göster",
        thats_it: "Şimdi başlayın"
      }
    },
    my_area: {
      heading: {
        welcome: "Bölgenize hoş geldiniz",
        my_area: "Benim bölgem",
        create_time: "Zaman yaratın",
        change_time: "Doğru zaman",
        absences: "Devamsızlıklar ve başvurular",
        settings: "Kişisel ayarlar",
        thats_it: "Bu kadar!"
      },
      text: {
        welcome: "Çalışma zamanınızı verimli ve kolay bir şekilde yönetmenin daha da fazla yolunu keşfedin. Bölgenize bir göz atalım.",
        my_area: "Çalışma saatlerinizi ve fazla mesailerinizi anında görebileceğiniz merkezi bir yer. Buradan çalışma saatlerinizi yönetebilir, günlük günlüğünüze erişebilir, talep gönderebilir ve zamanlarınızı görüntüleyebilirsiniz.",
        create_time: "Saat girmeyi mi unuttunuz ya da daha sonra saat eklemek mi istiyorsunuz? Hiç sorun değil! Eksik süreleri ekleyin, molaları kaydedin ve çalışma süresi hesabınızı güncel tutun.",
        change_time: "Sürelerinizi düzeltmek mi istiyorsunuz? Hiç sorun değil! Clockin ile yanlış zamanları kolayca düzeltebilir ve ayarlayabilirsiniz.",
        absences: "Tatil taleplerini, hastalık günlerini ve diğer devamsızlıkları yönetin. Taleplerinizin durumunu her zaman takip edin ve sadece birkaç tıklama ile yenilerini hızlı ve kolay bir şekilde gönderin.",
        settings: "Şirkete mesaj gönderin veya kişisel ayarlarınızı değiştirin ve şifrenizi değiştirmek istiyorsanız, bunu da buradan yapabilirsiniz!",
        thats_it: "Başardınız! Artık zamanınızı zahmetsizce yönetebilir, devamsızlıkları düzenleyebilir ve önemli olana, yani işinize konsantre olabilirsiniz. Verimli zamanınız için iyi şanslar!"
      },
      button: {
        welcome: "Bana nasıl yapıldığını göster",
        thats_it: "Şimdi başlayın"
      }
    },
    clock: {
      clockin_now: "Şimdi kilitlenin",
      clock_your_first_time_now: "& ilk seferinizi kaydedin"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Clockin'i kullandığınız için teşekkürler!",
      question: "clockin'i arkadaşlarınıza veya meslektaşlarınıza tavsiye etme olasılığınız nedir?",
      very_likely: "Büyük olasılıkla",
      very_unlikely: "Pek olası değil",
      help_us_improve: "Sizin için clockin'i nasıl geliştirebiliriz?",
      what_do_you_agree_with: "Hangi ifadelere katılırsınız?",
      choose_three_statements: "En fazla üç ifade seçin.",
      hard_to_use: "Çalıştırması zor",
      lacking_features: "Çok az fonksiyon",
      does_not_help_me: "iş günümü hiç kolaylaştırmıyor",
      confusing: "Kafa karıştırıcı",
      poorly_implemented: "Kötü uygulanan işlevler",
      too_buggy: "çok hata eğilimli",
      too_slow: "Uzun yükleme süreleri",
      what_else: "Bize söylemek istediğiniz başka bir şey var mı?",
      can_we_ask_you_a_few_questions: "Size birkaç soru daha sorabilir miyiz?",
      how_happy_are_you_with_the_introduction_of_clockin: "Şirketinizde saat uygulamasına geçilmesinden ne kadar memnunsunuz?",
      how_much_do_you_enjoy_using_clockin: "Clockin'i kullanmayı nasıl buluyorsun?",
      how_much_easier_does_clockin_make_your_work: "Clockin günlük işlerinizi ne kadar kolaylaştırıyor?",
      how_happy_are_you_with_the_following_aspects: "Aşağıdaki hususlardan ne kadar memnunsunuz?",
      clarity_of_the_app: "Uygulamanın netliği",
      simplicity_of_use: "Operasyon kolaylığı",
      app_features: "Uygulamadaki işlevler",
      feedback_received: "Geri bildiriminiz alınmıştır. Zaman ayırdığınız için teşekkür ederiz.",
      thanks_for_taking_the_time: "Zaman ayırdığınız için teşekkür ederim.",
      what_can_we_do_to_improve: "Bir dahaki sefere daha da iyisini yapabilmemiz için bize deneyiminiz hakkında daha fazla bilgi verebilir misiniz?",
      what_can_we_do_to_get_it_right: "Bir dahaki sefere doğru yapabilmemiz için bize deneyiminizden biraz daha bahsedebilir misiniz?",
      comment_placeholder: "Mesajınız"
    }
  },
  travel_logs: {
    add: "Yolculuk ayrıntılarını ekleyin",
    edit: "Yolculuk ayrıntılarını düzenleme",
    saving: "Yolculuk detayları kaydedilir...",
    saved_successfully: "Yolculuk detayları başarıyla kaydedildi!",
    unable_to_save: "Ne yazık ki, bu işe yaramadı 😢"
  },
  attach_file: "Dosya ekle",
  image_to_text: {
    info: "Metnin açıkça tanınabilir olduğundan ve görsel üzerinde tam olarak görülebildiğinden emin olun.",
    attach_image: "Resim ekleyin",
    processing: "Metniniz okunacaktır.",
    processing_failed: "Ne yazık ki, içe aktarma çalışmadı 😢",
    no_text_found: "Hiçbir metin tanınamadı."
  },
  correction_enter_reason: "Lütfen düzeltme için bir neden belirtin.",
  daily_notes: {
    add: "Bir not yazın",
    edit: "Düzenleme notu",
    saving: "Not kaydedildi...",
    saved_successfully: "Not başarıyla kaydedildi!",
    unable_to_save: "Ne yazık ki, bu işe yaramadı 😢",
    no_notes_yet: "Not oluşturulmadı",
    create_note: "Oluştur"
  },
  calendar_sync: {
    title: "Zamanlamayı Senkronize Et",
    description: "Çalışma programınızı bir takvimle senkronize edin ve eski ve yeni randevuları takip edin.",
    url: "iCal formatında adres",
    url_description: "Bu takvime diğer uygulamalardan erişmek için bu adresi kullanabilirsiniz.",
    note: "İpucu",
    note_description: "Bazı takvimlerde yeni randevuların görüntülenmesi 24 saate kadar sürebilir.",
    sync_now: "Takvimi senkronize edin",
    copied: "Takvim url'si kopyalandı."
  },
  registration: {
    skip_all: "Tümünü atla",
    already_signed_up: "Zaten bir hesabım var",
    title_1: "Hadi başlayalım! Clockin ile hangi saatleri kaydetmek istersiniz?",
    description_1: "Clockin'i sizin için özelleştirelim",
    option_1_a: "Genel çalışma süresi (geliş, gidiş ve mola)",
    option_1_b: "Proje çalışma saatleri",
    title_2: "Belgelemek ister misiniz?",
    description_2: "Bunun için hangi gereklilikler yerine getirilmelidir?",
    option_2_a: "Fotoğraflar",
    option_2_b: "Eskizler",
    option_2_c: "Not fonksiyonu",
    option_2_d: "Kontrol Listeleri ve Formlar",
    option_2_e: "Dijital proje dosyaları",
    title_3: "Başka neleri dijitalleştirmek istersiniz?",
    description_3: "Clockin'de keşfedilecek çok şey var, belki sizin için de bir şeyler vardır.",
    option_3_a: "Tatil",
    option_3_b: "Hastalıklar ve devamsızlıklar",
    option_3_c: "Dijital personel dosyası",
    option_3_d: "Şirket analizi",
    option_3_e: "Dağıtım planlaması",
    option_3_f: "Veri transferi vergi danışmanı (DATEV)",
    title_4: "Şirketiniz hangi sektörde faaliyet gösteriyor?",
    description_4: "Sizi daha iyi tanımak istiyoruz, böylece clockin'i ihtiyaçlarınıza daha uygun hale getirebiliriz.",
    option_4_a: "HİZMETLER",
    option_4_b: "Zanaat",
    option_4_c: "Sağlık ve zindelik",
    option_4_d: "Satın alma, sipariş ve ticaret",
    option_4_e: "Otel ve catering",
    option_4_f: "Araba, Nakliye ve Makine",
    option_4_g: "Diğer sektörler",
    title_5: "Şirketinizin kaç çalışanı var?",
    description_5: "Çalışan sayısıyla birlikte, şirketinizin büyüklüğüne göre saati özelleştirebiliriz.",
    title_6: "Süper! Saatiniz şimdi ayarlandı",
    description_6: "Tek ihtiyacımız olan isminiz.",
    input_6_a: "Şirket",
    input_6_b: "İlk isim",
    input_6_c: "Soyadı",
    input_6_d: "Telefon numarası",
    title_7: "Gitmeye hazırsınız! Clockin'i 14 gün ücretsiz deneyin!",
    input_7_a: "E-posta adresiniz",
    description_7: "Şifrenizi hangi e-posta adresine göndermeliyiz?",
    input_7_b: "Bu şekilde farkına vardım.",
    how_did_you_hear_about_clockin: "Clockin'i ilk nasıl duydunuz?",
    recommendation_option_1: "Tavsiye",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "İnternet araması",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Karşılaştırma platformu",
    recommendation_option_7: "Dergi ve çevrimiçi makaleler",
    known_from: "Bilinen",
    agb_1: "Formu göndererek, aşağıdaki şartları kabul etmiş olursunuz ",
    agb_2: 'AGB',
    agb_3: " ve ",
    agb_4: "Gizlilik Politikası",
    start: "Testi başlat",
    validation_failed: "Lütfen tüm alanları doğru şekilde doldurun."
  },
  clocki: {
    listening_heading: "– Seni dinliyorum",
    listening_subtext: "Size nasıl yardımcı olabilirim?",
    hi_0: "Merhaba, size nasıl yardımcı olabilirim?",
    hi_1: "Hey, size nasıl yardımcı olabilirim?",
    hi_2: "Merhaba, size nasıl yardımcı olabilirim?",
    hi_3: "Moin moin, senin için ne yapabilirim?",
    hi_4: "Merhaba, sizin için ne yapabilirim?",
    hi_5: "Merhaba, size nasıl yardımcı olabilirim?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Maalesef, ses tanıma özelliği cihazınızda çalışmıyor gibi görünüyor",
    microphone_permission_denied: "Maalesef mikrofonunuza erişimim yok. Sizi duyabilmem için lütfen ayarlardaki yetkileri kontrol edin.",
    please_speak: "Artık Clocki ile konuşabilirsiniz",
    create_activity: "Bir etkinlik oluşturun",
    modify_activity: "Etkinliği Değiştir",
    delete_activity: "Etkinliği sil",
    create_daily_note: "Günlük not oluşturma",
    search_project: "Bir proje arayın",
    note_copied: "Not kopyalandı",
    create_absence_request: "İstek devamsızlığı",
    delete_absence: "Devamsızlığı sil",
    confirm_deletion: "Emin misin ki senin {activity_label} Damgalama {date} saat silinmeli mi?",
    confirm_absence_deletion: "Talebinizin {category} İtibaren {startDate} kadar {endDate} Silmek mi istiyorsunuz?",
    task_before_modification: "Önce: {task}",
    starts_at_before_modification: "Önceki başlama zamanı: {startsAt}",
    ends_at_before_modification: "Önceki bitiş zamanı: {endsAt}",
    something_went_wrong: "Oh, bir şeyler ters gitti, lütfen daha sonra tekrar deneyin.",
    was_this_helpful: "Clocki size yardımcı olabilir mi?",
    actions: {
      CREATE_ABSENCE: {
        title: "Devamsızlığı onaylayın"
      },
      CREATE_DAILY_NOTE: {
        title: "Şimdi bir not oluşturun",
        daily_notes_disabled: "Maalesef not fonksiyonu devre dışı bırakılmıştır. Lütfen yöneticinizden ofis merkezindeki işlevi etkinleştirmesini isteyin.",
        success: "Not günlük günlüğüne başarıyla kaydedildi 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Belgeleri şimdi oluşturun",
        created_by_clocki: "Clocki ile oluşturuldu"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "\"Zamanlarım \"ı şimdi açın"
      },
      REDIRECT_TO_MY_AREA: {
        title: "Şimdi \"Alanım \"ı açın"
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Şimdi \"Şifre değiştir \"i açın"
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Şimdi \"çalışma süresini\" damgalayın",
        PAUSE: "Şimdi \"Duraklat\" damgasını basın",
        DRIVING_TIME: "Şimdi \"yolculuk süresi\" damgasını vurun",
        LOGOUT: "Şimdi kilidi aç"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Clockin'i kullanmayı sever misiniz?"
  },
  translation_failed: "Ne yazık ki, çeviri işe yaramadı 😕",
  video_transcript_not_available: "Transkript mevcut değil",
  video_upload_succeeded: "Video yüklemesi tamamlandı.",
  video_upload_failed: "Video yükleme başarısız oldu.",
  video_send_failed: "Video şu anda yayınlanamadı. Sonra tekrar deneyeceğiz.",
  uploading_video: "Video yükleniyor...",
  language_selection_header: "Dil seçin",
  language_selection_message: "Tercih ettiğiniz dili seçin",
  shifts: {
    my_shifts: "Vardiyalarım",
    free_shifts: "Serbest vardiyalar",
    next_shift: "Bir sonraki vardiyanız",
    shift_not_found: "Katman bulunmadı",
    show_shift_plan: "Bu vardiya programını görüntüleyin",
    no_shift_place: "Konum belirtilmedi",
    no_shifts_assigned: "Şu anda hiçbir vardiyaya atanmıyorsunuz",
    free_shifts_unavailable: "Şu anda ücretsiz vardiyalar mevcut değil",
    filter_shift_plans: "Vardiya Programlarını Filtrele",
    no_shift_plans_available: "Vardiya programı mevcut değil",
    filter_locations: "Filtre yerleri",
    no_locations_available: "Yer yok",
    no_plan_selected: "Vardiya programı seçilmedi",
    no_shifts_for_plan: "Bu plan için katman bulunamadı.",
    no_shifts_for_location: "Seçilen konumda vardiyalar bulunmadı",
    unknown_shift_plan: "Vardiya programı bilinmiyor",
    unknown_location: "Bilinmeyen yer",
    loading_more_shifts: "Daha fazla katman yükle..."
  },
  clockin_reminder_title: "Zaten işte misin? 🔔",
  clockin_reminder: "Giriş yapmayı unutma.",
  clockout_reminder_title: "Zaten günün sonunda mısın? 🔔",
  clockout_reminder: "Çıkış yapmayı unutma.",
  choose_clockin_reminder_time: "Giriş hatırlatma saati",
  choose_clockout_reminder_time: "Çalışma çıkışı hatırlatma saati",
  choose_break_reminder_time: "Duraklama Süresi",
  saved_successfully: "Başarıyla kurtarıldı 👍",
  clock_reminder_channel_name: "Pul Hatırlatıcıları",
  clock_reminder_channel_description: "Giriş ve çıkış hatırlatmaları",
  break_reminder_title: "Hâlâ ara veriyor musun? ⏰",
  break_reminder: "Not: Mola süreniz hâlâ devam ediyor.",
  // Video component translations
  video_not_supported: "Cihazınız videoyu desteklemiyor :/",
  video_loading_error: "Video yükleme hatası",
  video_retry: "Yeniden Yükleme"
};